var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77902 0C13.6281 0 17.558 3.98694 17.558 8.90625C17.558 13.8256 13.6281 17.8125 8.77902 17.8125C3.92998 17.8125 0 13.8256 0 8.90625C0 3.98694 3.92998 0 8.77902 0Z",
    fill: "url(#paint0_radial_172_2069)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57985 6.87788C7.34594 5.12794 10.2128 5.12794 11.9789 6.87788L12.1915 7.0901C12.2807 7.17708 12.2807 7.31972 12.1915 7.40669L11.4645 8.12685C11.42 8.17207 11.3479 8.17207 11.3034 8.12685L11.0119 7.83809C9.77732 6.61696 7.78146 6.61696 6.54691 7.83809L6.23485 8.14772C6.19026 8.19295 6.11825 8.19295 6.07367 8.14772L5.34666 7.42757C5.25749 7.34059 5.25749 7.19795 5.34666 7.11098L5.57985 6.87788ZM13.4844 8.3669L14.1325 9.00703C14.2217 9.09401 14.2217 9.23665 14.1325 9.32362L11.2142 12.2147C11.125 12.3017 10.981 12.3017 10.8953 12.2147L8.82397 10.1621C8.80339 10.1412 8.76567 10.1412 8.7451 10.1621L6.6738 12.2147C6.58464 12.3017 6.4406 12.3017 6.35487 12.2147L3.42625 9.32362C3.33708 9.23665 3.33708 9.09401 3.42625 9.00703L4.07438 8.3669C4.16355 8.27992 4.30758 8.27992 4.39331 8.3669L6.46461 10.4195C6.48519 10.4404 6.52291 10.4404 6.54348 10.4195L8.61478 8.3669C8.70395 8.27992 8.84798 8.27992 8.93371 8.3669L11.005 10.4195C11.0256 10.4404 11.0633 10.4404 11.0839 10.4195L13.1552 8.3669C13.2512 8.27992 13.3952 8.27992 13.4844 8.3669Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_172_2069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.44201e-05 8.90653) scale(17.558 17.8125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.8e5011b302c9fcf19a28daedd5e063cb.svg";
export { ForwardRef as ReactComponent };